import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StepsDataStore } from 'src/app/models';
import { MANAGE_STEPS } from 'src/app/stubs/steps.stub.spec';
import Utils from 'src/app/utils/utils';
import { HorizontalStepModel } from 'src/app/models/step.model';

const STEPS_DATA_STORE = {
  1: undefined,
  2: undefined,
  3: undefined,
};

@Injectable({
  providedIn: 'root',
})
export class ManageStepperService{
  steps$: BehaviorSubject<HorizontalStepModel[]> = new BehaviorSubject<HorizontalStepModel[]>(
    MANAGE_STEPS
  );
  currentStep$: BehaviorSubject<HorizontalStepModel> = new BehaviorSubject<HorizontalStepModel>(
    MANAGE_STEPS[0]
  );
  public stepsDataStore: StepsDataStore = STEPS_DATA_STORE;

  constructor() {
    this.stepsDataStore = Utils.loadFromLocalStorage('cacheManageSteps');
    this.currentStep$.next(this.steps$.value[0]);
  }

  get steps() {
    return this.steps$.getValue();
  }

  get currentStep() {
    return this.currentStep$.getValue();
  }

  setCurrentStep(step: HorizontalStepModel): void {
    this.currentStep$.next(step);
  }

  getCurrentStep(): Observable<HorizontalStepModel> {
    return this.currentStep$.asObservable();
  }

  getSteps(): Observable<HorizontalStepModel[]> {
    return this.steps$.asObservable();
  }

  prevStep(): void {
    if (this.isFirstStep()) {
      return;
    }
    const step = this.steps.find(
      (step) => step.stepIndex === this.currentStep.stepIndex - 1
    );
    if (step) {
      this.setCurrentStep(step);
    }
  }

  moveToNextStep(data: any = {}): void {
    const index = this.updateStepData(data);
    let nextStep: HorizontalStepModel =
      this.steps.find((step) => step.stepIndex === index + 1) ||
      this.steps[index];
    nextStep.isComplete = true;
    nextStep = { ...nextStep, data: data };
    if (index < this.steps$.value.length) {
      this.setCurrentStep(nextStep);
    }
  }

  updateStepData(data: any): number {
    const index = this.currentStep$.value.stepIndex;
    this.currentStep.data = data;
    this.stepsDataStore[index] = this.currentStep;
    return index;
  }

  goToFirstStep() {
    this.setCurrentStep(MANAGE_STEPS[0]);
  }

  isLastStep(): boolean {
    return this.currentStep$.value.stepIndex === this.steps$.value[this.steps$.value.length - 1].stepIndex;
  }

  isFirstStep(): boolean {
    return this.currentStep$.value.stepIndex === this.steps$.value[0].stepIndex;
  }

  cleanDataStored(): void {
    this.stepsDataStore = { ...STEPS_DATA_STORE };
  }
}
